export default {
    listagem: {
        titulo_pagina: 'Clases Auxiliares de Integración',
        novo: 'Crear Nueva Clase Auxiliar',
        table: {
            empty: 'No se encontró ninguna clase auxiliar',
            nome: 'Nombre',
            classe: 'Clase',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nueva Clase Auxiliar',
            editar: 'Editar Clase Auxiliar'
        },
        fields: {
            nome: {
                label: 'Nombre',
                description: 'Nombre de la clase auxiliar'
            },
            classe: {
                label: 'Clase',
                description: 'Clase auxiliar'
            },
            status: {
                label: 'Estado',
                description: 'Estado activo o inactivo'
            },
            botao_salvar : 'Guardar Auxiliar'
        },
        create: {
            success: '¡Clase auxiliar creada con éxito!',
            error: '¡Error al crear la clase auxiliar!'
        },
        update: {
            success: '¡Clase de ayuda editada con éxito!',
            error: '¡Error al editar la clase auxiliar!'
        }
    }
}
